import { Fragment, useState } from 'react'

import { Seo } from '../components'
import Scrollytelling from '../features/scrollytelling/Scrollytelling'
import AivyBalance from '../features/scrollytelling/usecases/balance/AivyBalance'
import CandidateStory from '../features/scrollytelling/usecases/bewerbende/CandidateStory'
import DemoStory from '../features/scrollytelling/usecases/demo/DemoStory'
import AivyLanes from '../features/scrollytelling/usecases/lanes/AivyLanes'
import AivyMorph from '../features/scrollytelling/usecases/morph/AivyMorph'
import AivyPlay from '../features/scrollytelling/usecases/play/AivyPlay'
import CandidateShowcase, {
  CandidateShowcaseLight
} from '../features/scrollytelling/usecases/showcase/bewerbende/CandidateShowcase'
import DemoShowcase, {
  DemoShowcaseLight
} from '../features/scrollytelling/usecases/showcase/demo/DemoShowcase'
import ScrollytellingV10 from '../features/scrollytelling/v10/ScrollytellingV10'
import ScrollytellingV2 from '../features/scrollytelling/v2/ScrollytellingV2'
import ScrollytellingV3 from '../features/scrollytelling/v3/ScrollytellingV3'
import ScrollytellingV4 from '../features/scrollytelling/v4/ScrollytellingV4'
import ScrollytellingV5 from '../features/scrollytelling/v5/ScrollytellingV5'
import ScrollytellingV6 from '../features/scrollytelling/v6/ScrollytellingV6'
import ScrollytellingV7 from '../features/scrollytelling/v7/ScrollytellingV7'
import ScrollytellingV8 from '../features/scrollytelling/v8/ScrollytellingV8'
import ScrollytellingV9 from '../features/scrollytelling/v9/ScrollytellingV9'

// Interne Showcase-Seite (nicht in der Sidebar verlinkt): Bewerbung bis Zusage als Scrollytelling.
// Die gewaehlte Version steht in ?v=, so laesst sich ein Link direkt auf eine Version teilen.
// Die Use Cases nutzen Version 2 „Cinematic“ fuer andere Geschichten (Demo, Bewerbende).

const USE_CASES = [
  {
    id: 'aivy-balance',
    name: 'Produkt-Demo · Aivy Balance',
    title: 'Aivy Balance',
    Component: AivyBalance
  },
  {
    id: 'aivy-lanes',
    name: 'Produkt-Demo · Aivy Spalten',
    title: 'Aivy Spalten',
    Component: AivyLanes
  },
  {
    id: 'aivy-morph',
    name: 'Produkt-Demo · Aivy Morph',
    title: 'Aivy Morph',
    Component: AivyMorph
  },
  {
    id: 'aivy-play',
    name: 'Produkt-Demo · Aivy Play',
    title: 'Aivy Produkt-Demo',
    Component: AivyPlay
  },
  {
    id: 'demo-showcase-hell',
    name: 'Produkt-Demo · Showcase hell',
    title: 'Aivy Produkt-Demo',
    Component: DemoShowcaseLight
  },
  {
    id: 'bewerbende-showcase-hell',
    name: 'Bewerbenden-Infopage · Showcase hell',
    title: 'Aivy für Bewerbende',
    Component: CandidateShowcaseLight
  },
  {
    id: 'demo-showcase',
    name: 'Produkt-Demo · Showcase',
    title: 'Aivy Produkt-Demo',
    Component: DemoShowcase
  },
  {
    id: 'bewerbende-showcase',
    name: 'Bewerbenden-Infopage · Showcase',
    title: 'Aivy für Bewerbende',
    Component: CandidateShowcase
  },
  {
    id: 'demo',
    name: 'Produkt-Demo · Cinematic',
    title: 'Aivy Produkt-Demo',
    Component: DemoStory
  },
  {
    id: 'bewerbende',
    name: 'Bewerbenden-Infopage · Cinematic',
    title: 'Aivy für Bewerbende',
    Component: CandidateStory
  }
]

const VERSIONS = [
  {
    id: 'werdegang',
    name: 'Version 10 · Lenas Werdegang',
    Component: ScrollytellingV10
  },
  {
    id: 'woche',
    name: 'Version 9 · Deine Recruiting-Woche',
    Component: ScrollytellingV9
  },
  {
    id: 'headlines',
    name: 'Version 8 · Headlines',
    Component: ScrollytellingV8
  },
  {
    id: 'baukasten',
    name: 'Version 7 · Baukasten',
    Component: ScrollytellingV7
  },
  {
    id: 'interaktiv',
    name: 'Version 6 · Interaktiv',
    Component: ScrollytellingV6
  },
  {
    id: 'kombi',
    name: 'Version 5 · Kombi aus Office und Mensch',
    Component: ScrollytellingV5
  },
  {
    id: 'mensch',
    name: 'Version 4 · Der Mensch hinter dem Lebenslauf',
    Component: ScrollytellingV4
  },
  {
    id: 'office',
    name: 'Version 3 · Miniatur-Office',
    Component: ScrollytellingV3
  },
  {
    id: 'cinematic',
    name: 'Version 2 · Cinematic',
    Component: ScrollytellingV2
  },
  { id: 'klassisch', name: 'Version 1 · Klassisch', Component: Scrollytelling }
]

const ALL = [...VERSIONS, ...USE_CASES]

const readVersion = () => {
  const id = new URLSearchParams(window.location.search).get('v')
  return ALL.find((v) => v.id === id) || VERSIONS[0]
}

const ScrollytellingPage = () => {
  const [version, setVersion] = useState(readVersion)

  const choose = (id) => {
    const next = ALL.find((v) => v.id === id)
    if (!next) return
    const url = new URL(window.location.href)
    url.searchParams.set('v', id)
    window.history.replaceState(null, '', url)
    window.scrollTo({ top: 0, behavior: 'auto' })
    setVersion(next)
  }

  return (
    <Fragment>
      <Seo title={version.title || 'Von der Bewerbung bis zur Zusage'} />
      <div className='fixed bottom-4 left-4 z-50 lg:bottom-auto lg:left-auto lg:right-5 lg:top-4'>
        <label className='sr-only' htmlFor='scrollytelling-version'>
          Version
        </label>
        <select
          id='scrollytelling-version'
          value={version.id}
          onChange={(e) => choose(e.target.value)}
          className='rounded-xl border-gray-300 bg-white py-2 pl-3 pr-9 text-sm font-medium text-gray-900 focus:border-[#407BFF] focus:ring-[#407BFF]'
        >
          <optgroup label='Bewerbung bis Zusage'>
            {VERSIONS.map((v) => (
              <option key={v.id} value={v.id}>
                {v.name}
              </option>
            ))}
          </optgroup>
          <optgroup label='Use Cases'>
            {USE_CASES.map((v) => (
              <option key={v.id} value={v.id}>
                {v.name}
              </option>
            ))}
          </optgroup>
        </select>
      </div>
      <version.Component key={version.id} />
    </Fragment>
  )
}

export default ScrollytellingPage
